import { Slot } from '@radix-ui/react-slot'
import { cn } from '@seen/ui'
import { type ComponentPropsWithoutRef, forwardRef } from 'react'

export interface ScrollAreaContentProps extends ComponentPropsWithoutRef<'div'> {
  asChild?: boolean
}

export const ScrollAreaContent = forwardRef<
  HTMLDivElement,
  ScrollAreaContentProps
>(({ asChild, className, ...delegated }, ref) => {
  const Comp = asChild ? Slot : 'div'
  return (
    <Comp
      className={cn('flex flex-col gap-3 px-4 pb-4', 'flex-1', className)}
      {...delegated}
      ref={ref}
    />
  )
})

ScrollAreaContent.displayName = 'ScrollAreaContent'
